const CDN_IMAGE_CONSTANTS = {
  scene7ImageBaseUrl: 'https://target.scene7.com/is/image/Target/',
  curalateImageBaseUrl: 'https://edge.curalate.com/v1/img/'
};

export { CDN_IMAGE_CONSTANTS };
